import { render, staticRenderFns } from "./MasterDetailLayout.vue?vue&type=template&id=15908404&scoped=true&"
import script from "./MasterDetailLayout.vue?vue&type=script&lang=js&"
export * from "./MasterDetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./MasterDetailLayout.vue?vue&type=style&index=0&id=15908404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15908404",
  null
  
)

export default component.exports